module.exports = __webpack_public_path__ + "static/index/img/baikal-506.d4017dec.jpg";